import React, { useState } from 'react'
import NotificationManagement from '../components/NotificationManagement/NotificationManagement'

const NotificationManagementPage = () => {
  return (
    <>
      <NotificationManagement />
    </>
  )
}

export default NotificationManagementPage
